import * as React from 'react';
import { connect } from 'react-redux';
import { ClientShortHandName, mainHostnameFromHostname } from '@snoam/mono-scc';
import { getIdentity } from '../actions/Actions';
import * as CustomTypes from '../CustomTypes';
import { createStartPageFullUrl, getBasename } from '../fastflowUtils';
import {
  AlignItems,
  classNames,
  Container,
  ContainerWidth,
  Display,
  FlexDirection,
  Height,
  JustifyContent,
  Padding,
  Width,
  Link,
} from '@snoam/pinata';

export interface IStateProps {
  productInfo: CustomTypes.IProductInfo;
  referer: CustomTypes.IReferer;
  sessionInfo: CustomTypes.ISessionInfo;
}

const styleClass = {
  container: classNames(
    Display.FLEX,
    FlexDirection.FLEX_ROW,
    JustifyContent.JUSTIFY_BETWEEN,
    AlignItems.ITEMS_CENTER,
    Padding.P_4,
  ),
  img: classNames(Width.W_56, Height.H_AUTO),
  root: classNames(
    Display.FLEX,
    FlexDirection.FLEX_ROW,
    JustifyContent.JUSTIFY_BETWEEN,
  ),
};

export class Header extends React.Component<
  IStateProps,
  Record<string, never>
> {
  public static displayName = 'Header';

  constructor(props: IStateProps) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  public render() {
    const { givenName } = this.props.sessionInfo;
    const domain = mainHostnameFromHostname(window.location.hostname);
    const basename = getBasename();
    return (
      <div className={classNames(styleClass.root)}>
        <Container width={ContainerWidth.WIDE} className={styleClass.container}>
          <Link
            href={`//${domain}`}
            tabIndex={-1}
            className={styleClass.img}
            title="Magasin pluss"
          >
            <img
              className={styleClass.img}
              src={`${basename}img/logos/magasinpluss.svg`}
              alt="Magasin pluss"
            />
          </Link>

          <div>
            <span className={classNames(Padding.PR_4)}>{givenName}</span>
            {givenName && (
              <Link onClick={this.logout} onKeyDown={this.handleKeyDown}>
                Logg ut
              </Link>
            )}
          </div>
        </Container>
      </div>
    );
  }

  private logout() {
    const { owningClient, productId } = this.props.productInfo;
    const startPageFullUrl = createStartPageFullUrl(productId);
    getIdentity(owningClient as ClientShortHandName).logout(startPageFullUrl);
  }

  private handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.keyCode === 32 || e.keyCode === 13) {
      this.logout();
    }
  };
}

export default connect<IStateProps>((state: IStateProps) => ({
  productInfo: state.productInfo,
  referer: state.referer,
  sessionInfo: state.sessionInfo,
}))(Header);
